import { Geolocation } from "@capacitor/geolocation";

export default async function currentLocation() {
	try {
		// 1. Check current permission status
		let permissions = await Geolocation.checkPermissions();

		// 2. Request permission if it hasn't been granted yet
		if (permissions.location !== "granted") {
			permissions = await Geolocation.requestPermissions();
		}

		// 3. If the user still denies it, exit early
		if (permissions.location !== "granted") {
			console.warn("User denied location permission.");
			// You can trigger a UI alert here telling the user why you need it
			return false;
		}

		// 4. Permission is granted, fetch the position
		const coordinates = await Geolocation.getCurrentPosition();
		return coordinates;
	} catch (error) {
		console.error("Geolocation error:", error);
		return false;
	}
}
